(ns app.front.view.committees.template-editor
  (:require [app.domain.committee.model :as committee-model]
            [app.front.entities :as entities]
            [app.front.ui.template-editor :as template-editor]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::fetch-default-template
  (fn [_ _]
    {:comm/command {:command    :committee/default-template
                    :method     :get
                    :on-success [::fetch-default-template.success]}}))

(rf/reg-event-fx ::fetch-default-template.success
  (fn [{:keys [db]} [_ _ data]]
    {:db (-> db
             (assoc ::default-template data))}))

(rf/reg-sub ::committee
  (fn [[_ committee-id]]
    (rf/subscribe [::entities/entity committee-id]))
  (fn [committee-entity _] committee-entity))

(rf/reg-sub ::default-template
  :-> ::default-template)

(rf/reg-sub ::template
  (fn [[_ committee-id]]
    [(rf/subscribe [::default-template])
     (rf/subscribe [::committee committee-id])])
  (fn [[default-template committee] _]
    (->> committee
         :committee/agenda-template
         (filter (comp some? val))
         (into {})
         (merge default-template))))

(rf/reg-event-fx ::save
  (fn [_ [_ committee-id data]]
    {:comm/command {:command    :committee/save-template
                    :data       (-> data
                                    (assoc :committee-id committee-id))
                    :on-success [::entities/apply-changes]
                    :notify     {:success :committee/template-saved}}}))

(defn view [match]
  (let [committee-id                         (-> match :parameters :path :committee-id)
        {:committee/keys [name]}             (<sub [::committee committee-id])
        {:committee-template/keys
         [agenda-pdf-html-template
          agenda-pdf-item-html-snippet
          agenda-pdf-deficiency-html-snippet
          agenda-pdf-css-template]
         :as template}                       (<sub [::template committee-id])
        tr                                   (<sub [:tr])]
    [acommon/admin-page (util/mmap {:title (tr [:committee-meeting/edit-agenda-template]
                                               [name])}
                                   match)
     (if-not template
       (cc/loading-spinner {:with-overlay true})
       [template-editor/editor
        {:html-template agenda-pdf-html-template
         :print-css     agenda-pdf-css-template
         :tr            tr
         :on-save       #(>evt [::save
                                committee-id
                                {:committee-template/agenda-pdf-html-template %1
                                 :committee-template/agenda-pdf-css-template  %2}])
         :title         (tr [:committee/agenda-pdf-template])
         :placeholders  committee-model/agenda-template-variables
         :images        (<sub [::gas/meeting-agenda-images (-> match :parameters :group-id)])}
        [:<>
         [template-editor/editor
          {:html-template agenda-pdf-item-html-snippet
           :html-only?    true?
           :small?        true
           :tr            tr
           :on-save       #(>evt [::save
                                  committee-id
                                  {:committee-template/agenda-pdf-item-html-snippet %}])
           :title         (tr [:committee/agenda-item-snippet])
           :placeholders  (committee-model/agenda-item-picker-variables (<sub [::ff/enabled-flags]))
           :images        (<sub [::gas/meeting-agenda-images (-> match :parameters :group-id)])}]
         [template-editor/editor
          {:html-template agenda-pdf-deficiency-html-snippet
           :html-only?    true?
           :small?        true
           :tr            tr
           :on-save       #(>evt [::save
                                  committee-id
                                  {:committee-template/agenda-pdf-deficiency-html-snippet %}])
           :title         (tr [:committee/agenda-deficiency-snippet])
           :placeholders  committee-model/agenda-deficiency-template-variables
           :images        (<sub [::gas/meeting-agenda-images (-> match :parameters :group-id)])}]]])]))

(def route
  {:name        :view/group.admin.committee-agenda-template
   :view        view
   :parameters  {:path {:committee-id s/Int
                        :group-id     s/Int}}
   :controllers [{:start (fn [_]
                           (>evt [::fetch-default-template]))}]})
